import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='Poshmark'
        title='Poshmark Community: How To Join And Why It Matters'
      >
        <p>
          Beyond selling your pre-loved items, being on Poshmark dispenses several other advantages. Your initial goal
          may be about making a profit, but registering an account already integrates you to the buyer and seller
          community, also known as Poshers. With a vibrant community of over 80 million people across the US, Canada,
          Australia, and India, everyone is welcome to join the social marketplace.
        </p>
        <p>
          You may be wondering how can you benefit from the community when this reselling is something you only do
          part-time, much like many other casual sellers. From getting closet insights, seller tips, networking with
          Posh ambassadors, to earning extra money, here are reasons and ways you can make the most out of joining the
          platform.
        </p>
        <h3>Poshmark's Heart</h3>
        <p>
          With hundreds of online marketplaces out there, it may be tough to distinguish and know which one will work
          best for you and help you achieve your goals as a seller. Some are straightforward in their platform that they
          only focus on shoppers getting the best experience.
        </p>
        <p>
          For Poshmark, at its center is the community of sellers and buyers who, by way of creating attractive listings
          and sharing great finds, create a wonderful experience for long-time and new Poshers.
        </p>
        <p>
          This is why marketplaces launch social events, whether online or physical, to bring together the next
          generation of retailers to network, discuss insights and experiences, and come up with ways to deliver a great
          social shopping experience for all users.
        </p>
        <h3>Social Commerce</h3>
        <p>
          Poshmark has regular community-hosted events geared towards growing your business. These are social or
          educational events that will greatly benefit you as a seller, whether reselling is your full-time business or
          it is something you only enjoy doing part-time.{' '}
        </p>
        <h3>Posh Party Live</h3>
        <p>
          By joining this event, you will have the opportunity to network with other members, learn tips from Posh
          ambassadors, know where to get resources, take photos, and so much more.
        </p>
        <p>
          At the moment, tickets for these events are free. This is why it is important to secure your slots early as
          the event has a limited amount for now.
        </p>
        <p>
          To access the live event, you have to register to a Hopin account and then sign in here, to receive the direct
          link of the event. Signing up on another platform may seem like extra work but it is worth it once you are
          already inside the event. Poshmark created a short guide for you to better follow it.
        </p>
        <p>
          For you to see and anticipate future events, keep your inbox and app notifications on. Poshmark sends out an
          announcement for anything exciting you have to look out for.
        </p>
        <h3>Posh Fest </h3>
        <p>
          The second annual event you have to check out is this two-day conference for entrepreneurs. This gives you the
          opportunity to gain connections within the community and to get inspiration for your own businesses.
        </p>
        <p>
          You can hear success stories, fundamentals to e-commerce, and meet PFFs (Posh Friends Forever). However,
          unlike Posh Party Live, you have to buy tickets for you to be able to attend a Posh Fest. In the US and in
          Canada, each ticket costs $49.
        </p>
        <p>
          Once you have secured your spot, you can also check the agenda for you to better prepare and know what you are
          about to see.
        </p>
        <p>
          Currently, Poshfest is held virtually, given the pandemic. Hopefully, soon, Poshmark can host physical live
          events and fests.
        </p>
        <h3>Posh N Sip </h3>
        <p>
          This is another great way to get involved with Poshers through meetups to exchange tips, network, and make
          friends! Given the COVID health crisis, these are currently done virtually to ensure the safety of the
          community. The beauty of online meetups is that you can still work within your schedule.
        </p>
        <p>
          Aside from learning from fellow sellers and buyers through seminars or casual sharing, you can also do virtual
          brunches or coffee dates. As this is something casual and held online, you can easily share any inspiration
          for what you can sell. After all, style enthusiasts love sharing ideas and mood boards they compile from apps
          like Instagram and Pinterest.
        </p>
        <p>
          To get to know other people's experiences, you can look up #PoshLove and #PoshNSip on Twitter or Instagram.
          This is a great way for you or someone you are inviting to get the motivation to be active within the
          community.
        </p>
        <p>
          What you need to do is to keep yourself posted by regularly checking the website for any future Posh N Sip
          events.
        </p>
        <h3>Strong community</h3>
        <p>
          There are many success stories in Poshmark. Some members were previous employees who got tired of the 9-5
          shift, some are stay-at-home mothers, dads, physically challenged individuals, and even college students. All
          of them are grateful to Poshmark because it does not only provide the tools to fulfill their dreams of running
          their own businesses, but also provides the network or community.
        </p>
        <p>
          Many Poshers have other social media accounts where they share tips, tricks, and listing hauls. The social
          interactions garnered here strengthen business relationships and of course, lifelong friends made along the
          way.
        </p>
        <h3>YouTube Channels</h3>
        <p>
          This platform is one of the best ways to get to know Poshers as they share tips that they have acquired
          through the months/years they were with the online marketplace. Some even give step-by-step guides on how to
          be successful in e-commerce, especially when selling secondhand items, sourcing inventory, and dealing with
          shipping, USPS, or other delivery concerns.
        </p>
        <h3>Facebook Groups </h3>
        <p>
          Poshmark’s Facebook page has amassed a whopping 2 million followers. More than just a shopping destination, it
          is composed of a community that helps each other out about anything under e-commerce.
        </p>
        <p>
          Once you connect with them, you can share your listings. That way, more people will be able to see and access
          the items you sell. They can give tips and who knows, they may become one of your loyal customers as well
        </p>
        !
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
